/* eslint-disable jsx-a11y/alt-text */
import ball from '../../images/ball.svg';

export const BallIcon = () => (
  <img src={ball} width={14} height={14} />
)
